import favicon from "../assets/favicons/favicon_adiacom.ico";

export const Config = {
    serviceUrl: "https://ac-dev01.adia.tv",
    serviceIdFromUrl: true,
    customAssetsDomain: "d2ip04c7fw7crb.cloudfront.net",
    keldanoDomain: "d13hluefk1re66.cloudfront.net",
    favicon,
};
